import { Spacer, ThemeProvider, Typography } from "@aircall/tractor";

import * as S from "./FeatureBanner.styled";

import { FeatureBannerProps } from ".";

export function FeatureBanner({
  children,
  content,
  icon: Icon,
  maxW,
  fluid,
  direction = "horizontal",
  alignItems = "center",
  "data-test": dataTest = "feature-banner",
}: FeatureBannerProps) {
  return (
    <ThemeProvider>
      <S.StyledSpacer
        direction={direction}
        alignItems={alignItems}
        justifyContent="space-between"
        maxW={maxW}
        w={fluid ? "100%" : "auto"}
        py="s"
        px="m"
        space="s"
        border="1px solid #C2FFEC"
        borderRadius="16px"
        data-test={dataTest}
      >
        <Spacer space="s" alignItems="center">
          {Icon}
          <Typography variant="bodySemiboldM">{content}</Typography>
        </Spacer>
        {children}
      </S.StyledSpacer>
    </ThemeProvider>
  );
}
